import ActiveRecord from './active_record/base'

class Invoice extends ActiveRecord {
	static tableName = 'billingInvoices'
}

export default Invoice
